var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPowerTransmissionStationsAndPowerStations = function SvgPowerTransmissionStationsAndPowerStations(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#21272C",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.56,
    d: "M12 22.098c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10c0 5.522 4.477 10 10 10Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#002BFF",
    d: "M15.64 7.208V10.258c0 .04 0 .06-.05.09-.57.3-1.14.61-1.72.92-.02 0-.03.01-.06.03v-1.81c-1.21.61-2.42 1.21-3.63 1.82v-1.82s-.04.02-.05.02c-1.17.59-2.35 1.18-3.53 1.76-.04.02-.06.04-.06.09v5.65h10.9v-9.8h-1.81z"
  })));
};
export default SvgPowerTransmissionStationsAndPowerStations;